import axios from 'axios'
import { BUSCAR_PESSOA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { apenasNumero } from '../../util/inputs';

export default function recuperarPessoaPorCpfCnpj (cpfCnpj) {
  const cpfCnpjSemFormatacao = apenasNumero(cpfCnpj)
  const url = `${URL}/pessoas/cpf-cnpj/${cpfCnpjSemFormatacao}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_PESSOA,
        payload: response
      })
  );
}
